module.exports = __webpack_public_path__ + "img/pillow_3.bb0d5e23.png";